import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { ComboBoxFormControl } from './combobox-form-control';

@Component({
  standalone: false,
  selector: 'app-combobox-form-control',
  templateUrl: './combobox-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboBoxFormControlComponent),
      multi: true
    }
  ]
})
export class ComboBoxFormControlComponent
  extends AbstractFormControlComponent<ComboBoxFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() wrongAnswer: string = undefined;
  @Output() onChanged: EventEmitter<boolean> = new EventEmitter();

  faCheck: any = faCheck;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    if (this.control.value === this.wrongAnswer) {
      this.control.patchValue(undefined);
    }
    this.onChanged.emit(this.control.value);
  }

  public get collection(): any[] {
    return this.control.collection || [];
  }

  public get keyPropertyName(): string {
    return this.control.keyPropertyName || 'name';
  }

  public get valuePropertyName(): string {
    return this.control.valuePropertyName || 'name';
  }

  public isSelected(value: any): boolean {
    return this.control.value == value;
  }
}
